<template>
    <b-container fluid>
      <b-row>
        <b-col>
          <div class="mb-2">
            <router-link :to="{ name: 'Riskcomponent', params: { id: item.id }}"><h5>{{item.name}} [{{item.id}}]</h5></router-link>
            <div>deleted: {{item.del}}</div>
          </div>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import ac from '@/libs/accesscontrol'

export default {
  name: 'RiskcomponentSimple',
  props: ['item', 'username'],
  computed: {
    user: {
      get () {
        return this.$store.state.user
      }
    }
  },
  created: async function () {
    this.permission.edit = ac.can(this.user.acgroups).updateAny('riskcomponent').granted
  },
  data () {
    return {
      permission: {
        edit: false
      }
    }
  }
}
</script>

<style>
</style>
